
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import firebase from '../services/firebase';
import { useNavigate } from 'react-router-dom';
import { setUser } from '../redux/actions/userActions';
import { SignIn } from './Login';
import { ToastContainer, toast } from 'react-toastify';
import { clearCartItems } from '../redux/actions/cartActions';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from '../components/Loader';
import { Underline } from '../components/Underline';

import { addItemToCart, removeItemFromCart, updateCartItemQuantity } from '../redux/actions/cartActions';

export const Cart = () => {
  const cart = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [address, setAddress] = useState({
    line1: '',
    line2: '',
    city: '',
    state: '',
    pincode: '',
    name: '',
    phone: '',
  });
  const [deliveryType, setDeliveryType] = useState('regular');
  const [packagingType, setPackagingType] = useState('regular');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user.isAuthenticated) {
      setAddress({
        ...address,
        name: user.name,
        phone: user.phoneNumber,
      });
    } else {
      getUserData();
    }
  }, [user]);

  const getUserData = async () => {
    try {
      const userData = await firebase.getUser(user.uid);
      if (userData.exists) {
        dispatch(setUser({ ...userData.data(), isAuthenticated: true }));
        setAddress({
          ...address,
          name: userData.data().name,
          phone: userData.data().phoneNumber,
        });
      }
    } catch (error) {
      console.error('Error getting user data:', error);
    }
  };

  const handleAddressChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const handleIncreaseQuantity = (product, size) => {
    dispatch(addItemToCart({ product, size, quantity: 1 }));
  };

  const handleDecreaseQuantity = (productId, size) => {
    const existingItem = cart.cartItems.find(
      (item) => item.product.id === productId && item.size === size
    );

    if (existingItem.quantity === 1) {
      if (window.confirm('Are you sure you want to remove this item from the cart?')) {
        dispatch(removeItemFromCart({ productId, size }));
      }
    } else {
      dispatch(updateCartItemQuantity({ productId, size, quantity: existingItem.quantity - 1 }));
    }
  };


  const handleDeliveryTypeChange = (e) => {
    setDeliveryType(e.target.value);
  };

  const handlePackagingTypeChange = (e) => {
    setPackagingType(e.target.value);
  };

  const handlePlaceOrder = async () => {
    setLoading(true);

    // Check if all the fields are filled
    if (
      !address.line1 ||
      !address.line2 ||
      !address.city ||
      !address.state ||
      !address.pincode ||
      !address.name ||
      !address.phone
    ) {
      setLoading(false);
      toast.error('Please fill in all the required fields.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
      return;
    }

    try {
      // Save the address to Firestore
      await firebase.addAddress(address);

      // Create the order object
      const order = {
        items: cart.cartItems,
        total: cart.totalAmount,
        deliveryType,
        packagingType,
        address,
        uid: user.uid,
      };

      // Save the order to Firestore
      await firebase.placeOrder(order);
      setLoading(false);
      dispatch(clearCartItems());
      toast.success('Order placed successfully!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });

      setTimeout(() => {
        navigate('/profile');
      }, 1500);
    } catch (error) {
      setLoading(false);
      toast.error('Error placing order: ' + error.message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
      console.error('Error placing order:', error);
    }
  }; 

  return (
    <div className="flex flex-col h-full relative">
      {!user.isAuthenticated ? (
        <div className="flex w-full flex-row gap-[20px] h-full justify-center items-center">
          <SignIn />
        </div>
      ) : (
        <>
          {cart?.cartItems?.length === 0 && <div className='flex flex-col items-center justify-center bg-white p-8 px-5 w-full h-auto mb-[40px]'>
            <p className='text-2xl'>Cart Empty</p>
            
            <Underline></Underline>

            <p className='text-center'>There are no Items in the cart. Please add some items and come back. <br /> There are a couple of offers going on !! Add your items and enjoy the taste of indian-ness</p>
            <div className='flex flex-row gap-[20px] mt-[40px]'>
              <button
                className="bg-primary text-white text-md font-semibold mt-1 py-3 px-8"
                onClick={() => navigate('/shop')}
              >
                Continue Shopping
              </button>
              <button
                className="bg-gray-100 text-black text-md mt-1 py-3 px-8"
                onClick={() => navigate('/contact')}
              >
                Contact Us
              </button>
            </div>
          </div>}
          {cart?.cartItems?.length !== 0 && <div className="flex flex-col md:flex-row gap-[20px] w-full">
            <div className="flex flex-col w-full md:w-1/2 bg-white p-[20px] px-[30px] mb-auto">
              <p className="text-xl">Add Details</p>
              <Underline />

              <div className="flex flex-col">
                <div className="flex flex-col md:flex-row gap-[20px]">
                  <label className="flex flex-col w-full md:w-1/2">
                    Name :
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="Name"
                      name="name"
                      value={address.name}
                      onChange={handleAddressChange}
                    />
                  </label>
                  <label className="flex flex-col w-full md:w-1/2">
                    Phone Number
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="Phone Number"
                      name="phone"
                      value={address.phone}
                      onChange={handleAddressChange}
                    />
                  </label>
                </div>

                <div className="flex flex-col md:flex-row gap-[20px] mt-[20px]">
                  <label className="flex flex-col w-full md:w-1/2">
                    Line 1 :
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="Line 1"
                      name="line1"
                      value={address.line1}
                      onChange={handleAddressChange}
                    />
                  </label>
                  <label className="flex flex-col w-full md:w-1/2">
                    Line 2 :
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="Line 2"
                      name="line2"
                      value={address.line2}
                      onChange={handleAddressChange}
                    />
                  </label>
                </div>

                <div className="flex flex-col md:flex-row gap-[20px] mt-[20px]">
                  <label className="flex flex-col w-full md:w-1/2">
                    City :
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="City"
                      name="city"
                      value={address.city}
                      onChange={handleAddressChange}
                    />
                  </label>
                  <label className="flex flex-col w-full md:w-1/2">
                    State :
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="State"
                      name="state"
                      value={address.state}
                      onChange={handleAddressChange}
                    />
                  </label>
                </div>

                <div className="flex flex-col md:flex-row gap-[20px] mt-[20px]">
                  <label className="flex flex-col w-full md:w-1/2">
                    Country :
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="Country"
                      name="country"
                      value={address.country}
                      onChange={handleAddressChange}
                    />
                  </label>
                  <label className="flex flex-col w-full md:w-1/2">
                    Pincode :
                    <input
                      type="text"
                      className="bg-gray-100 p-2 px-4 mt-2"
                      placeholder="Pincode"
                      name="pincode"
                      value={address.pincode}
                      onChange={handleAddressChange}
                    />
                  </label>
                </div>
              </div>

              <div>
                <p className="text-xl mt-[40px]">Select Shipping Details</p>
                <Underline />

                <div className="flex flex-col md:flex-row gap-[20px]">
                  <div
                    onClick={() => {
                      setPackagingType('regular');
                    }}
                    className={`${
                      packagingType === 'regular'
                        ? 'bg-gray-100 text-black'
                        : 'bg-gray-100 text-black'
                    } cursor-pointer w-full md:w-1/2 p-4 flex flex-row`}
                  >
                    <div
                      className={`circle flex flex-col w-[30px] h-[30px] items-center justify-center rounded-full bg-white`}
                    >
                      <div
                        className={`${
                          packagingType === 'regular'
                            ? 'bg-primary'
                            : 'bg-gray-100'
                        } innercircle w-[17px] h-[17px] items-center justify-center rounded-full`}
                      ></div>
                    </div>
                    <div className="flex flex-col w-[80%] ml-auto">
                      <p className="text-lg font-bold">Regular Packaging</p>
                      <p className={`text-sm opacity-[0.3] font-bold`}>No extra charge</p>
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      setPackagingType('international');
                    }}
                    className={`${
                      packagingType === 'international'
                        ? 'bg-gray-100 text-black'
                        : 'bg-gray-100 text-black'
                    } cursor-pointer w-full md:w-1/2 p-4 flex flex-row`}
                  >
                    <div
                      className={`circle flex flex-col w-[30px] h-[30px] items-center justify-center rounded-full bg-white`}
                    >
                      <div
                        className={`${
                          packagingType === 'international'
                            ? 'bg-primary'
                            : 'bg-gray-100'
                        } innercircle w-[17px] h-[17px] items-center justify-center rounded-full`}
                      ></div>
                    </div>
                    <div className="flex flex-col w-[80%] ml-auto">
                      <p className="text-lg font-bold">International Packaging</p>
                      <p className={`text-sm font-bold`}>
                        <span className={`opacity-[0.3]`}>Chargable, </span>
                        <strong>₹ 50 Extra</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col w-full md:w-1/2 bg-white p-[20px] px-[30px] h-auto">
              <p className="text-xl">Cart Summary</p>
              <Underline />

              {cart?.cartItems?.map((item) => (
                <div
                  key={`${item.product.id}-${item.size}`}
                  className="bg-gray-100 flex flex-col md:flex-row p-3 mb-[10px] gap-[20px] w-full"
                >
                  <div className="flex flex-row md:flex-col gap-[10px]">
                    <div
                      className="bg-white hover:bg-primary hover:text-white hover:font-bold w-[35px] h-[35px] cursor-pointer flex flex-row items-center justify-center"
                      onClick={() => handleIncreaseQuantity(item.product, item.size)}
                    >
                      +
                    </div>
                    <div
                      className="bg-white hover:bg-primary hover:text-white hover:font-bold w-[35px] h-[35px] cursor-pointer flex flex-row items-center justify-center"
                      onClick={() => handleDecreaseQuantity(item.product.id, item.size)}
                    >
                      -
                    </div>
                  </div>
                  <img
                    src={item.product.image}
                    className="ml-[5px] h-auto md:h-[80px] !w-full md:!w-[80px] w-auto object-cover"
                    alt=""
                  />
                  <div className="flex flex-col md:ml-[20px] justify-center w-full md:w-[calc(100%-250px)] mr-auto">
                    <p className="text-lg">{item.product.name}</p>
                    <p className="text-sm text-gray-500 w-[90%]">
                      {item.product.description.length > 77
                        ? item.product.description.substring(0, 77) + '...'
                        : item.product.description}
                    </p>
                  </div>
                  <div className="flex flex-col items-end md:flex-start w-full md:w-[120px] gap-[10px]">
                    <p className="text-sm bg-white p-2 w-full text-center rounded-full">
                      {item.quantity} &nbsp; &nbsp; * &nbsp; &nbsp; {item.size}
                    </p>
                    <p className="text-sm bg-white p-2 w-full text-center rounded-full mt-auto">
                      ₹{item.product.price * item.quantity}
                    </p>
                  </div>
                </div>
              ))}

              <div className="flex flex-col md:flex-row items-center justify-center gap-[20px] mt-auto w-full">
                <button
                  className="bg-primary text-white text-md font-semibold mt-1 py-3 px-5 w-full md:w-1/2"
                  onClick={handlePlaceOrder}
                  disabled={loading}
                >
                  {loading ? (
                    <Loader />
                  ) : (
                    'Place Order  -   ₹ ' +
                    (packagingType === 'international'
                      ? cart.totalAmount + 50
                      : cart.totalAmount)
                  )}
                </button>
                <button
                  className="bg-gray-100 text-black text-md font-semibold mt-1 py-3 px-5 w-full md:w-1/2"
                  onClick={() => navigate('/shop')}
                >
                  Continue Shopping
                </button>
              </div>
            </div>
          </div>}
        </>
      )}
      <ToastContainer />
      <div className='h-[50px] w-full'></div>
    </div>
  );
};